let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2dYq2")).then(() => parcelRequire('4wo9L'));